import { Breadcrumb, Button, Card, Select, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import { amountFormat } from "../../../../services/common.service";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { depositAccountListSelector } from "../../../../store/selectors/app.selector";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";

export default function DepositDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const [tdDetails, setTDDetails] = useState({});
  const { t } = useTranslation();
  const accountList = useSelector(depositAccountListSelector);
  const [selectedAccountNo, setSelectedAccountNo] = useState(
    location.state.accountNo
  );
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");

  useEffect(() => {
    if (location.state) {
      console.log(location.state);
      setAccountDetails(location.state);
      getAccountSummaryByAccNo(location.state);
      // getTDAccDetails(location.state);
    }
  }, []);

  const getAccountSummaryByAccNo = useCallback(async (details) => {
    try {
      const response = await AccountService.getDepositAccountSummaryByAccNo({
        acctNo: details.accountNo,
        customerId: details.customerId,
        branchId: details?.branchId,
      });
      if (response.status === 200) {
        setAccountDetails(response.data);
      }
    } catch (error) {}
  }, []);

  const getTDAccDetails = useCallback(async (details) => {
    try {
      const response = await AccountService.getTDAccDetails({
        accountNo: details.accountNo,
      });
      if (response.status === 200) {
        setTDDetails(response.data);
      }
    } catch (error) {}
  }, []);

  const fetchDepositAdvise = useCallback(async () => {
    try {
      await AccountService.fetchDepositAdvise({
        tdAccountNumber: accountDetails?.acctNo,
      });
    } catch (error) {}
  }, [accountDetails]);

  const handleAccountNo = (value) => {
    setSelectedAccountNo(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    getAccountSummaryByAccNo(accountDet);
  };

  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "DETAILED_STATEMENT") {
      navigate("/accounts/deposit/statement", {
        state: accountDetails,
      });
    }
  };

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {" "}
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.deposits.deposit_summary", {
                defaultValue: "Deposit Summary",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.deposits.deposit_summary", {
                defaultValue: "Deposit Summary",
              })}
            </h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 hide-xs d-flex justify-content-end">
            <label style={{ fontSize: "18px", padding: "5px" }}>
              {t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}{" "}
              :{" "}
            </label>
            <Select
              placeholder={t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}
              bordered={true}
              optionLabelProp={"value"}
              size="large"
              value={selectedAccountNo}
              onChange={(value) => handleAccountNo(value)}
              style={{ width: "37%", textAlign: "justify" }}
            >
              {accountList.map((account, index) => (
                <Select.Option key={index} value={account.accountNo}>
                  <span className="acc-short-name">
                    {account?.acctShortName}
                  </span>
                  <br />
                  <span style={{ fontSize: "12px" }}>{account?.accountNo}</span>
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    {account?.branchName}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.my_accounts.deposits.deposit_summary", {
              defaultValue: "Deposit Summary",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>

          <Tabs.TabPane
            tab={t("pages.my_accounts.deposits.deposit_statement", {
              defaultValue: "Deposit Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
        </Tabs>
      </Card>

      <Card className="application-card">
        <div className="row">
          <span
            style={{
              display: "block",
              fontSize: "16px",
              color: "#252C32",
            }}
            className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
          >
            {t("pages.my_accounts.common_my_accounts.balance", {
              defaultValue: "Balance",
            })}
          </span>
          <h5
            style={{ margin: 0, fontWeight: "600" }}
            className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
            align="right"
          >
            <span>{amountFormat(accountDetails?.avlBalance || "0")}</span>
          </h5>
        </div>
      </Card>

      <div className="account-details">
        <Card className="mt-3 application-card">
          {accountDetails?.accountType === "FD" && (
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </label>
                <span className="d-flex">
                  {accountDetails?.accountType} &nbsp;
                  {accountDetails?.accountNo}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.casa.name", {
                    defaultValue: "Name",
                  })}
                </label>
                <span>{accountDetails?.accountName || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.sendMoney.payee.branch_name", {
                    defaultValue: "Branch Name",
                  })}
                </label>
                <span>{accountDetails?.branchName || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.open_date", {
                    defaultValue: "Open Date",
                  })}
                </label>
                <span>{accountDetails?.acctOpenDt || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.maturity_date", {
                    defaultValue: "Maturity Date",
                  })}
                </label>
                <span>{accountDetails?.maturityDate || "-"}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.rate_of_interest", {
                    defaultValue: "Rate of Interest",
                  })}
                </label>
                <span>{accountDetails?.interestRate || "0"} %</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.principle_amount", {
                    defaultValue: "Principle Amount",
                  })}
                </label>
                <span>
                  {amountFormat(accountDetails?.principalAmount || "0")}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.maturity_amount", {
                    defaultValue: "Maturity Amount",
                  })}
                </label>
                <span>
                  {amountFormat(accountDetails?.maturityAmount || "0")}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.tenure", {
                    defaultValue: "Tenure",
                  })}
                </label>
                <span>{accountDetails?.tenure}</span>
              </div>
              {accountDetails !== undefined &&
                accountDetails.jointHolderNames !== undefined &&
                accountDetails.jointHolderNames?.length > 0 && (
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                    <label>
                      {t("pages.my_accounts.deposits.joint_holders", {
                        defaultValue: "Joint Holders",
                      })}
                    </label>
                    <span>
                      {" "}
                      {accountDetails !== undefined &&
                        accountDetails.jointHolderNames !== undefined &&
                        accountDetails.jointHolderNames.map((v) => {
                          return <>{v}</>;
                        })}
                    </span>
                  </div>
                )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.casa.nominee_registered", {
                    defaultValue: "Nominee Registered",
                  })}
                </label>
                <span>{accountDetails?.nomineeRegistered == "true"
                    ? t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      })}</span>
              </div>

              {accountDetails !== undefined &&
                accountDetails.nomineeDetails !== undefined &&
                accountDetails.nomineeDetails.map((v) => {
                  return (
                    <>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                        <label>
                          {t("pages.my_accounts.deposits.nominee_name", {
                            defaultValue: "Nominee name",
                          })}
                        </label>
                        <span>{v?.nomineeName || "-"}</span>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                        <label>
                          {t("pages.my_accounts.deposits.nominee_relation", {
                            defaultValue: "Nominee Relation",
                          })}
                        </label>
                        <span>{v?.nomieeRelationType || "-"}</span>
                      </div>
                    </>
                  );
                })}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.lien_amount", {
                    defaultValue: "Lien Amount",
                  })}
                </label>
                <span>{amountFormat(accountDetails?.lienAmt || "0")}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.maturity_notice", {
                    defaultValue: "Maturity Notice",
                  })}
                </label>
                <span>{accountDetails?.maturityNotice || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.interest_pay_out", {
                    defaultValue: "Interest Pay-out",
                  })}
                </label>
                <span>{accountDetails?.interestPayout || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.interest_amount", {
                    defaultValue: "Interest Amount",
                  })}
                </label>
                <span>{amountFormat(tdDetails?.interestAmount || "-")}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.auto_renewal", {
                    defaultValue: "Auto Renewal",
                  })}
                </label>
                <span>
                  {accountDetails?.autoRenewal === "N"
                    ? t("buttons.no_btn", {
                        defaultValue: "No",
                      })
                    : t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })}
                </span>
              </div>

              {accountDetails?.autoRenewal &&
                accountDetails?.autoRenewal !== "N" && (
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                    <label>
                      {t("pages.my_accounts.deposits.auto_renewal_date", {
                        defaultValue: "Auto renewal date",
                      })}
                    </label>
                    <span>{accountDetails?.maturityDate || "-"}</span>
                  </div>
                )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.auto_closure", {
                    defaultValue: "Auto Closure",
                  })}
                </label>
                <span>
                  {tdDetails?.autoClosure == "Y"
                    ? t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.repayment_account", {
                    defaultValue: "Repayment Account",
                  })}
                </label>
                {accountDetails?.repaymentAccount !== undefined &&
                accountDetails?.repaymentAccount?.length > 0 ? (
                  <span>{accountDetails?.repaymentAccount || "-"}</span>
                ) : (
                  <span>-</span>
                )}
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.account_status", {
                    defaultValue: "Account Status",
                  })}
                </label>
                <span>{accountDetails?.status || "-"}</span>
              </div>
            </div>
          )}

          {accountDetails?.accountType === "RD" && (
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </label>
                <span className="d-flex">
                  {accountDetails?.accountType} &nbsp;
                  {accountDetails?.accountNo}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.casa.name", {
                    defaultValue: "Name",
                  })}
                </label>
                <span>{accountDetails?.accountName || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.sendMoney.payee.branch_name", {
                    defaultValue: "Branch Name",
                  })}
                </label>
                <span>{accountDetails?.acctBranchDesc || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.deposits.open_date", {
                    defaultValue: "Open Date",
                  })}
                </label>
                <span>{accountDetails?.acctOpenDt || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.deposits.maturity_date", {
                    defaultValue: "Maturity Date",
                  })}
                </label>
                <span>{accountDetails?.maturityDate || "-"}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.deposits.rate_of_interest", {
                    defaultValue: "Rate of Interest",
                  })}
                </label>
                <span>{accountDetails?.interestRate || "0"} %</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.instalment_amount", {
                    defaultValue: "Instalment Amount",
                  })}
                </label>
                <span>{amountFormat(accountDetails?.depositAmt || "0")}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.maturity_amount", {
                    defaultValue: "Maturity Amount",
                  })}
                </label>
                <span>{amountFormat(accountDetails?.maturityAmt || "0")}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.deposits.tenure", {
                    defaultValue: "Tenure",
                  })}
                </label>
                <span>
                  {accountDetails?.depositMonths === "0"
                    ? ""
                    : accountDetails?.depositMonths + " Months"}{" "}
                  {accountDetails?.depositDays === "0"
                    ? ""
                    : accountDetails?.depositDays + " Days"}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.next_instalment_date", {
                    defaultValue: "Next Instalment Date",
                  })}
                </label>
                <span>{accountDetails?.nextInstalmentDate || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.pending_instalments", {
                    defaultValue: "PENDING instalments",
                  })}
                </label>
                <span>
                  {accountDetails?.pendingInstalments || "0"}
                  {accountDetails.pendingInstalments != null &&
                    accountDetails.pendingInstalments > 0 && (
                      <div
                        className="d-inline links primary-color"
                        style={{
                          marginLeft: 10,
                          fontSize: 13,
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate("/accounts/deposit/payee", {
                            state: accountDetails,
                          })
                        }
                      >
                        {t("pages.fundtransfer.pay_now", {
                          defaultValue: "Pay Now",
                        })}
                      </div>
                    )}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.amount_to_be_paid", {
                    defaultValue: "Amount to be paid",
                  })}
                </label>
                <span>
                  {amountFormat(accountDetails?.pendingInstalmentsAmt || "0")}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.si_collection", {
                    defaultValue: "SI Collection A/c details",
                  })}
                </label>
                <span>{"-"}</span>

                {/* `${
                  accNoDetails.siCollectionAccount
                    ? accountNumberFormatter(accNoDetails.siCollectionAccount)
                    : accNoDetails.siCollectionAccount
                }\n${accNoDetails.siCollectionBank}\n${
                  accNoDetails.siCollectionBranch
                }` */}
              </div>

              {accountDetails !== undefined &&
                accountDetails.jointHolderNames !== undefined &&
                accountDetails.jointHolderNames?.length > 0 && (
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                    <label>
                      {" "}
                      {t("pages.my_accounts.deposits.joint_holders", {
                        defaultValue: "Joint Holders",
                      })}
                    </label>
                    <span>
                      {" "}
                      {accountDetails !== undefined &&
                        accountDetails.jointHolderNames !== undefined &&
                        accountDetails.jointHolderNames.map((v) => {
                          return <>{v}</>;
                        })}
                    </span>
                  </div>
                )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.casa.nominee_registered", {
                    defaultValue: "Nominee Registered",
                  })}
                </label>
                <span>{accountDetails?.nomineeRegistered == "true"
                    ? t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      })}</span>
              </div>

              {accountDetails !== undefined &&
                accountDetails.nomineeDetails !== undefined &&
                accountDetails.nomineeDetails.map((v) => {
                  return (
                    <>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                        <label>
                          {t("pages.my_accounts.deposits.nominee_name", {
                            defaultValue: "Nominee name",
                          })}
                        </label>
                        <span>{v?.nomineeName || "-"}</span>
                      </div>

                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                        <label>
                          {" "}
                          {t("pages.my_accounts.deposits.nominee_relation", {
                            defaultValue: "Nominee Relation",
                          })}
                        </label>
                        <span>{v?.nomineeRelation || "-"}</span>
                      </div>
                    </>
                  );
                })}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {t("pages.my_accounts.deposits.lien_amount", {
                    defaultValue: "Lien Amount",
                  })}
                </label>
                <span>{amountFormat(accountDetails?.lienAmt || "0")}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.deposits.auto_renewal", {
                    defaultValue: "Auto Renewal",
                  })}
                </label>
                <span>{accountDetails?.autoRenewalFlag || "-"}</span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-3">
                <label>
                  {" "}
                  {t("pages.my_accounts.deposits.repayment_account", {
                    defaultValue: "Repayment Account",
                  })}
                </label>
                {accountDetails?.repmtAcct !== undefined &&
                accountDetails?.repmtAcct?.length > 0 ? (
                  <span>{accountDetails?.repmtAcct || "-"}</span>
                ) : (
                  "-"
                )}
              </div>
            </div>
          )}
        </Card>
      </div>
    </>
  );
}
